
$(() => {
    try {
        document
            .getElementById("showFull")

            .addEventListener("click", () => {
                const m = document.getElementById("showMore");
                const l = document.getElementById("showLess");
                m.style.display = "block";
                l.style.display = "none";
            });
    } catch (e) {}



    try {
        document
            .getElementById("showShort")

            .addEventListener("click", () => {
                const m = document.getElementById("showMore");
                const l = document.getElementById("showLess");
                m.style.display = "none";
                l.style.display = "block";
            });
    } catch (e) {}


    let lastHospitalId = null; // To keep track of the last hospital ID

    const getFirstAvailable = function(doctorId, hospitalId, ts, bookDoctorLink) {

       // if (hospitalId === lastHospitalId) return; // Skip if the same hospital ID

        lastHospitalId = hospitalId; // Update the last hospital ID


        $.ajaxSetup({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
            }
        });
        $.ajax({
            url: 'https://maxapp.in/api/session/first_available',
            type: "get",
            data: {
                doc_id: doctorId,
                clinic_id: hospitalId,
                ts: ts
            },
            dataType: "json"
        })
        .done(function(response) {

            if (response.status == 1) {

                if(response.first_available_response.length > 0){

                if (response.slotDetails.length === 0) {
                    var f_avail = response.first_available_response[0].procedures[0].s_date;
                    var next_available_date =  moment(f_avail).format('DD-MMM-YYYY');

                    $('.success-message').removeAttr("style");
                    $('.success-message').html(
                        '<p class="mb-0 font-weight-semi-bold">No slot available for online booking on selected date. <b style="font-weight: 800;">Doctor is available</b> on <b class="underline-text" style="font-weight: 800; text-decoration: underline;">'+next_available_date+'</b></p>'
                    );
                    $('#book-doctor-link').text('Request an Appointment');
                    $('.bookDoctorLink').attr('href', `${bookDoctorLink}&ts=${ts}`);
                    $("a#book-doctor-link").attr("href", `${bookDoctorLink}&ts=${ts}`);

                }else{
                    let total_slots = 0;
                    response.slotDetails.map(slotData => {
                        if (slotData.appointment_date == moment(ts).format('YYYY-MM-DD')) {
                            total_slots += slotData.availableSlots;
                        }
                    })

                    $('.success-message').removeAttr("style");

                    $('.success-message').html(
                        '<p class="mb-0 font-weight-semi-bold"><b style="font-weight: 800;">'+total_slots +
                        ' slots available</b> for online booking. <b style="font-weight: 800;">To book an appointment</b>, ' +
                        ' <a  class="bookDoctorLink color-white hover-color-white hover-underline text-underline font-weight-bold" href="'+`${bookDoctorLink}&ts=${ts}`+'"><b style="font-weight: 800;">Click Here</b></a></p><script>$(".bookDoctorLink").on("click", function(){  window.location.href = $(this).attr("href"); });</script>'
                    );
                    $('#book-doctor-link').text('Book an Appointment');
                    //$('.bookDoctorLink').attr('href', `${bookDoctorLink}&ts=${ts}`);
                    $("a#book-doctor-link").attr("href", `${bookDoctorLink}&ts=${ts}`);
                }


                } else {
                    $('.success-message').removeAttr("style");
                    $('.success-message').html(
                        '<p class="mb-0 font-weight-semi-bold">No slot available for online booking.<b style="font-weight: 800;"> To request for an appointment</b>' +
                        ' <a class="bookDoctorLink color-white hover-color-white hover-underline text-underline font-weight-bold" href="'+`${bookDoctorLink}&ts=${ts}`+'" ><b style="font-weight: 800;">Click Here</b></a></p><script>$(".bookDoctorLink").on("click", function(){  window.location.href = $(this).attr("href"); });</script>'
                    );
                    $('#book-doctor-link').text('Request an Appointment');
                  //  $('.bookDoctorLink').attr('href', `${bookDoctorLink}&ts=${ts}`);
                    $("a#book-doctor-link").attr("href", `${bookDoctorLink}&ts=${ts}`);

                }
            } else {
                $('.success-message').removeAttr("style");
                    $('.success-message').html(
                        '<p class="mb-0 font-weight-semi-bold">No slot available for online booking.<b style="font-weight: 800;"> To request for an appointment</b>' +
                        ' <a class="bookDoctorLink color-white hover-color-white hover-underline text-underline font-weight-bold" href="'+`${bookDoctorLink}&ts=${ts}`+'" ><b style="font-weight: 800;">Click Here</b></a></p><script>$(".bookDoctorLink").on("click", function(){  window.location.href = $(this).attr("href"); });</script>'
                    );
                    $('#book-doctor-link').text('Request an Appointment');
                  //  $('.bookDoctorLink').attr('href', `${bookDoctorLink}&ts=${ts}`);
                    $("a#book-doctor-link").attr("href", `${bookDoctorLink}&ts=${ts}`);
            }
        })
        .fail(function(error) {
            // Handle fail case
        });
    };



const initDateCalendar2 = function (doctorId, hospitalId, bookDoctorLink) {
    const startDate = new Date();
    startDate.setHours(0, 0, 0, 0); // Reset time to midnight

    if (!$.fn.datepicker) return false;

    function isTodayOrFuture(date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date >= today;
    }

    var conntDiv = 0;

    $(".date-calendar")
        .datepicker("destroy")
        .datepicker({
            templates: {
                leftArrow:
                    "<span class='d-flex align-items-center justify-content-start cursor-pointer'><i class='fas fa-chevron-left mr-2'></i> Prev</span>",
                rightArrow:
                    "<span class='d-flex align-items-center justify-content-end cursor-pointer'>Next <i class='fas fa-chevron-right ml-2'></i></span>",
            },
            todayHighlight: false,
            startDate: startDate,
            format: "yyyy-mm-dd",
            maxViewMode: "month",
            minViewMode: "month",
            autoclose: true,
            defaultViewDate: false,
            setDate: null,
            beforeShowDay: function (date) {
                const classes = [];
                const mainColor = "text-color-blue";

                if (isTodayOrFuture(date)) {
                    classes.push(mainColor);
                } else {
                    classes.push("disabled");
                }

                return { classes: classes.join(" ") };
            },
        })
        .off("changeDate")
        .on("changeDate", function (e) {
            let date = e.format() + " 12:00:00 GMT+5:30";
            let ts = new Date(date.replace(/-/g, "/")).getTime();

            var bookDoctorLink = $('input[name="chooseHospital"]:checked').attr("data-slug");
            var doctorId = $('input[name="chooseHospital"]:checked').attr("data-doc-id");
            var hospitalId = $('input[name="chooseHospital"]:checked').val();

            if (hospitalId != undefined) {
                getFirstAvailable(doctorId, hospitalId, ts, bookDoctorLink);
            } else {
                $(".success-message").removeAttr("style");

                if (conntDiv == 0) {
                    conntDiv = 1;
                    $(".table-condensed thead").append(
                        '<tr><th colspan="7" class="success-message" id="success-message"></th></tr>'
                    );
                }
                $(".success-message").html(
                    '<p class="mb-0 font-weight-semi-bold">Please select a hospital first.</p>'
                );
            }
        });
};


    initDateCalendar2();


    function initializeCalendar() {



        $(".date-calendar").datepicker("destroy"); // Ensure we destroy any previous calendar instance




        $('input[name="chooseHospital"]:checked').each(function() {
            var bookDoctorLink = $(this).attr("data-slug");
            var doctorId = $(this).attr("data-doc-id");
            var hospitalId = $(this).val();
            initDateCalendar2(doctorId, hospitalId, bookDoctorLink);
            $(".table-condensed thead").append('<tr class="apnd"><th colspan="7" class="success-message" id="success-message"></th></tr>');
        });
    }

    $('input[name="chooseHospital"]').on("click", function() {
        initializeCalendar();
        $('.success-message').css('display', 'none');
    });





    $("#share").on("click", function(e) {
        let $self = $(this);
        let input = document.createElement("input");
        input.setAttribute("value", window.location.href);
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        $self.find("span").text("Copied");

        setTimeout(function() {
            $("#shareComplete").modal("toggle");
            $self.find("span").text("Copy Link");
        }, 1000);
    });

});
